import { render } from "./LoginComponent.vue?vue&type=template&id=a8b8cde0&scoped=true"
import script from "./LoginComponent.vue?vue&type=script&lang=js"
export * from "./LoginComponent.vue?vue&type=script&lang=js"

import "./LoginComponent.vue?vue&type=style&index=0&id=a8b8cde0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8b8cde0"]])

export default __exports__